/* unplugin-vue-components disabled */import script from "./QuickSkillPreviewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickSkillPreviewCard.vue?vue&type=script&setup=true&lang=js"

import "./QuickSkillPreviewCard.vue?vue&type=style&index=0&id=e2cc22bc&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2cc22bc"]])

export default __exports__